import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconColorFan24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconColorFan24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 17v3a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5m0-1.937q.1-.025.206-.042L7.5 8.45V5a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zM9 5.852l.654-1.133a2 2 0 0 1 2.732-.732l2.864 1.654a2 2 0 0 1 .732 2.732l-.34.589.6-.347a2 2 0 0 1 2.732.732l1.654 2.865a2 2 0 0 1-.732 2.732L19.8 15h.2a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2zm10.146 7.793L16.8 15H8.184l8.808-5.086a.5.5 0 0 1 .683.183l1.654 2.865a.5.5 0 0 1-.183.683m-6.102-3.183-7.46 4.307 5.369-9.3a.5.5 0 0 1 .683-.183L14.5 6.94a.5.5 0 0 1 .183.683z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconColorFan24);
